import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { fetcher } from "../../client";
import {
  contractAction,
  resendContract,
  sendContract,
  createContract,
} from "../../actions/contracts";

import { capitalize } from "../../../utils";
import { useHistory } from "react-router";

export function useContractAction(options = {}) {
  const { t } = useTranslation();

  return useMutation(
    ({ contractId, action, ...payload }) =>
      fetcher(contractAction(contractId, action, payload)),
    {
      ...options,
      onError: (error) => {
        toast.error(t(`errors.${error.message}`));
        if (options.onError) options.onError();
      },
    }
  );
}

export function useResendContract(options = {}) {
  const { t } = useTranslation();

  return useMutation((payload) => fetcher(resendContract(payload)), {
    ...options,
    onSuccess: (data, variables) => {
      if (options.onSuccess) options.onSuccess(data, variables);
      toast.info(
        t("successMessages.resentContract", {
          participant: capitalize(variables.participantName),
        }),
        { autoClose: 3000 }
      );
    },
    onError: (error, variables) => {
      toast.error(
        t(`errorMessages.${error.message}`, "errorMessages.generalError"),
        { autoClose: 3000 }
      );
      if (options.onError) options.onError(error, variables);
    },
  });
}

export function useSendContract(options = {}) {
  const { t } = useTranslation();

  return useMutation((payload) => fetcher(sendContract(payload)), {
    ...options,
    onSuccess: (data, variables) => {
      if (options.onSuccess) options.onSuccess(data, variables);
      toast.info(t("El contrato ha sido enviado"), { autoClose: 3000 });
    },
    onError: (error, variables) => {
      if (options.onError) options.onError(error, variables);
      toast.error(
        t(`errorMessages.${error.message}`, "errorMessages.generalError"),
        { autoClose: 3000 }
      );
    },
  });
}

export function useCreateContract(options = {}) {
  const { t } = useTranslation();

  return useMutation(
    (payload) => fetcher(createContract(payload)),

    {
      ...options,

      onError: (error, variables) => {
        if (options.onError) options.onError(error, variables);
        toast.error(
          t(`errors.${error.message}`, t("errorMessages.generalError"))
        );
      },
    }
  );
}
